import { connect } from 'react-redux'
import { DraggingHint } from 'aria-viewer/common'

const mapStateToProps = state => ({
    isVisible: state.getIn(['interactiveElements', 'draggingHint', 'isVisible']),
    delay: state.getIn(['interactiveElements', 'draggingHint', 'delay']),
    showAnimation: state.getIn(['device', 'isDeviceDesktop']),
})

export default connect(mapStateToProps)(DraggingHint)
